// import "../../../userList/userList.css";
import { useContext, useEffect, useRef, useState } from "react";
import { CartContext } from "../../../../contexts/cartContext";
import apiDemy from "../../../../../utils/apiDemy";
import ToastNote from "../../../../golbal/notifications/toastNote";
// import Tooltip1 from "../../../../golbal/tooltip/tooltip";
import ColoredSpinner from "../../../../alret/spiners/coloredSpiner/coloredSpinner";
// import SearchBarUser from "../profile/transactions/myTrans/searchBarUser";
// import MyIcons from "../../../../golbal/icons/myIcons";
import tools from "../../../../../utils/tools";
import BlogSearch from "../../../../persian/common/pagination/searchPagination";
import { useNavigate, useSearchParams } from "react-router-dom";
import renderData from "../../../../../utils/renderData";
import demyData from "../../../../../utils/demyData";
import DropdownSearch from "../../../../golbal/dropdown/DropdownSearch";
import SearchMultiSelectFilters from "../../../../golbal/dropdown/searchMultiSelectFilters";
import Pagination from "../../../../golbal/pagination/pagination";
import countryStates from "../../../../../utils/countryStates";
import api from "../../../../../utils/api";
import { CircularProgress } from "@mui/material";
// import api from "../../../../../utils/api";
// import renderData from "../../../../../utils/renderData";


export default function DemyFinanBooked({ access }) {
  const navigate = useNavigate();
    // const section = "tutor";
    // const page = "tutorFilters";
      const [states, setStates] = useState([]);
      const [resultsTotal, setResultsTotal] = useState(0);
  const { user,signedUser } = useContext(CartContext);
  const [loading, setLoading] = useState({spinner:false});
  // const [user2, setUser2] = useState({ _id: user._id });
const [selectedSessions, setSelectedSessions] = useState({});

  const { lang, state:{state,stateShort}, country, countryShort } =
  tools.getItemFromLocalStorage("initSetup", {});
  const [searchParams, setSearchParams] = useSearchParams();
  const [data, setData] = useState([]);
   const [currencies, setCurrencies] = useState([
      { currency: "CAD", currency_name: "CAD", exRate: 1 },
      { currency: "USD", currency_name: "USD", exRate: 0.8 },
      { currency: "EUR", currency_name: "EUR", exRate: 0.7 },
      { currency: "AUD", currency_name: "AUD", exRate: 1.2 },
      { currency: "GBP", currency_name: "GBP", exRate: 0.6 },
      { currency: "IRR", currency_name: "ریال", exRate: 800000 },
    ]);
     async function fetchCurrencies() {
        setLoading((pre) => ({ ...pre, currencies: true }));
        const response = await api.getAcceptedCur({
          token: user.token,
          accepted: "all",
        });
        setLoading((pre) => ({ ...pre, currencies: false }));
        if (response.error)
          return messageRef.current.showError({
            message: ` ${response.error}`,
          });
        setCurrencies(response.data);
      }
  // console.log('user',user);
  // console.log('data',data);
  // console.log('selectedSessions',selectedSessions);
  const handleChange = (e) => {
  const value = e.target.value;
  // const exRate =
  //   e.target.options[e.target.selectedIndex].getAttribute("data-exRate");
  //   console.log(value, exRate);

    if (value !== "more")return setFilters((pre) => ({ ...pre, currency: value, }));

    fetchCurrencies();
  };
  const currentDate =  new Date();
  currentDate.setDate(1); // Set the day of the month to 1 to get the first day of the current month
  currentDate.setHours(0, 0, 0, 0); // Set hours, minutes, seconds, and milliseconds to zero
  const messageRef = useRef(null);
  const initialFilters = {
    lang:window.lang,
    currentDate,
    status: [],
    access,    
    country: "",
    countryShort: "",
    states: [],
    state: "",
    stateShort: "",
    cities: [],
    currency:"",
    hostId:"",
    hostName:"",
    studentId:"",
    studentName:"",
    paidByS:true,
    hasPayout:false,
    mainCatId: "",
    status: ["completed", "notRefunded", "noShowedS"],
    subCat: [],
    video: "",
    img: "",
    freeSession: "",  
    busName: "",
    searchKey: "",
    tag: "",
    weekDays: [],
    ageGroups: [],
    tutorLevel: [],
    serviceTypes: [],
    pageNumber: 1,
    itemsToShow: 15,
    sort: "default",
  };

const [filters, setFilters] = useState(initialFilters);
 const [backFilters, setBackFilters] = useState({ ...filters });


  useEffect(() => {
    // fetchData();
    filtersFunction();
  }, [filters]);

    function filtersFunction(){
    // console.log('useEffectRun01','filterFunction');    
    fetchData();
    setBackFilters({ ...filters });      
  }

  const totalPaid = Object.keys(selectedSessions)?.reduce((sum, currency) => {
  return sum + selectedSessions[currency].reduce((subSum, session) => {
    return subSum + (parseFloat(session.paidAmount) || 0);
  }, 0);
}, 0);

  async function fetchData() {
    setLoading(pre=>({...pre,spinner:true}))
    const response = await apiDemy.fetchBookedList({
      token: user.token,
      filters,    
    });
    setLoading(pre=>({...pre,spinner:false}))
    if (response.error)
      return messageRef.current.showError({ message: response.error });     
      setData(response.data.data);
      setResultsTotal(response.data.resultsTotal)

  }
   function queryRemover(field) {
    console.log(field);
    searchParams?.delete(field);
    // searchParams.set(field,"")
    const searchString = searchParams?.toString();
    setFilters((pre) => {
      const newFilters = { ...pre };
      delete newFilters[field];
      return newFilters;
    });
    navigate(`?${searchString}`);
  }
   async function searchHandle(e) {
      e.preventDefault();
      const value = e.target.parentElement.querySelector("input").value;
  
      filters.searchKey = value;
      if (e.key === "Enter" || e.type === "click") {
        setFilters((prev) => ({
          ...prev,
          searchKey: value,
          pageNumber: 1,
        }));
      }
    }
    const itemsToShowHandle = async (itemsToS) => {
      setFilters((prev) => ({
        ...prev,
        itemsToShow: itemsToS,
        pageNumber: 1,
      }));
    };
    const pageNumberHandle = (PageN) => {
      setFilters((prev) => ({
        ...prev,
        pageNumber: PageN,
      }));
    };
  
    function deleteFilter(e) {
      const field = e.currentTarget.id;
      queryRemover(field);
      function update() {
        let newFilters = { ...filters };
        for (let key in newFilters) {
          key == field
            ? (function () {
                newFilters[key] = "";
                // if (key === "mainCat") {
                //   newFilters.mainCatId = "";
                //   newFilters.subCat = [];
                //   newFilters.subCatId = [];
                //   queryRemover("mainCatId");
                // }
                if (key === "country") {
                  newFilters.countryShort = "";
                }
                newFilters.pageNumber = 1;
              })()
            : (newFilters[key] = newFilters[key]);
        }
        return newFilters;
      }
  
      // effectRan.current = false;
      setFilters(update());
    }
  
    function deleteArrayFilter(e) {
      const field = e.currentTarget.id.split(",")[0];
      const index = e.currentTarget.id.split(",")[1];
      queryRemover(field);
      function update() {
        let newFilters = { ...filters };
        for (let key in newFilters) {
          key == field
            ? (function () {
                newFilters[key].splice(index, 1);
                newFilters.pageNumber = 1;
                if (key === "subCat") {
                  newFilters.subCatId.splice(index, 1);
                  queryRemover("subCatId");
                }
              })()
            : (newFilters[key] = newFilters[key]);
        }
        return newFilters;
      }
      setFilters(update());
    }
    const getSessionPaymentStatus = (session) => {
    const totalPaid = session?.payouts
    ?.flatMap(p => p.sessions)
    ?.filter(s => s.sessionId === session._id)
    ?.reduce((sum, s) => sum + (s.paidAmount || 0), 0);      
  if (totalPaid >= session.sessionInfo.duration * session.sessionInfo.rate * 0.8) return "paid";
  if (totalPaid > 0) return "partial";
  return "pending";
};


const uploadFileDatabase = async (files) => {
  if (!files || files.length === 0) return;

  setLoading((pre) => ({ ...pre, spinner: true }));

  try {
    for (const file of files) {
      const formData = new FormData();
      formData.append("file", file);

      const response = await api.uploadSingleFile({
        token: user.token,
        formData,
        path: "images/payment/tutor",
      });

      if (response.error)return messageRef.current.showError({
          message: <div dir="ltr">{response.error}</div>,
        });
      
      

      // ✅ Update attachments for all selected sessions
      setSelectedSessions((prev) => {
        const updated = { ...prev };
        for (let currency in updated) {
          updated[currency] = updated[currency].map((session) => ({
            ...session,
            attachments: [...(session.attachments || []), response.data],
          }));
        }
        return updated;
      });

      console.log("Uploaded file response:", response.data);
    }

    // messageRef.current.showSuccess({
    //   message:
    //     "All files uploaded successfully. Don't forget to click the enter button.",
    // });
  } catch (err) {
    messageRef.current.showError({
      message: <div dir="ltr">Unexpected error during upload.</div>,
    });
    console.error(err);
  } finally {
    setLoading((pre) => ({ ...pre, spinner: false }));
  }
};
function calculatePaymentInfo(session) {
  const netAmount = session.sessionInfo.duration * session.sessionInfo.rate * 0.8;
  let totalPaid = 0;

  session?.payouts?.forEach(pay => {
    pay.sessions
      .filter(sf => sf.sessionId.toString() === session._id.toString())
      .forEach(sf => {
        totalPaid += sf.paidAmount;
      });
  });

  const balance = netAmount - totalPaid;

  return { netAmount, totalPaid, balance };
}
function PaymentHistory({ session, fetchPayoutDetail, balance }) {
  return (
    <div>
      {session?.payouts?.map(pay =>
        pay.sessions
          .filter(sf => sf.sessionId.toString() === session._id.toString())
          .map((sf, i) => (
            <div key={i} className="small-gray-font d-flex">
              <div>
                {sf.currency} {sf.paidAmount}
              </div>
              <div
                className="mx-2 link"
                data-bs-toggle="modal"
                data-bs-target="#bookingModal"
                onClick={() => fetchPayoutDetail({id:pay._id})}
              >
                View
              </div>
            </div>
          ))
      )}
 {balance > 0 && (
        <div className="small-gray-font text-pink-orange-dark">
          {session?.sessionInfo?.currency} {balance} Balance
        </div>
      )}
    </div>
  );
}


      
    const handleFileChange = (e) => {
  const selectedFiles = Array.from(e.target.files);
  if (selectedFiles.length > 0) {
    uploadFileDatabase( selectedFiles);
  }
  e.target.value = ""; // reset input
};

 
      const handleRemoveFile = (indexToRemove) => {
  setSelectedSessions((prev) => {
    const currency = Object.keys(selectedSessions)[0]
    console.log('currency',currency);    
    const updated = { ...prev };
    updated[currency] = updated[currency].map((session) =>
       ({...session,
            attachments: session.attachments.filter(
              (_, index) => index !== indexToRemove
            ),
          })
        
    );
    return updated;
  });
};

       
  const openFileInNewTab = (file) => {
    // const fileURL = URL.createObjectURL(file);
    // return console.log("fileURL",fileURL)
    window.open(file, '_blank');
  };


const handleReplaceFile = async (currency, sessionId, indexToReplace, newFile) => {
  try {
    setLoading((pre) => ({ ...pre, spinner: true }));

    const formData = new FormData();
    formData.append("file", newFile);

    const response = await api.uploadSingleFile({
      token: user.token,
      formData,
      path: "images/payment/tutor",
    });

    if (response.error)return   messageRef.current.showError({message: <div dir="ltr">{response.error}</div>,
      });
   

    setSelectedSessions((prev) => {
      const updated = { ...prev };

      updated[currency] = updated[currency].map((session) => {
        if (session.sessionId === sessionId) {
          const newAttachments = [...session.attachments];
          newAttachments[indexToReplace] = response.data; // Replace with uploaded file path
          return { ...session, attachments: newAttachments };
        }
        return session;
      });

      return updated;
    });

    messageRef.current.showSuccess({
      message: "File replaced successfully.",
    });
  } catch (err) {
    console.error(err);
    messageRef.current.showError({
      message: <div dir="ltr">Unexpected error while replacing file.</div>,
    });
  } finally {
    setLoading((pre) => ({ ...pre, spinner: false }));
  }
};


    function setSelectionsHandle(session){
      console.log("setSelectionsHandle session",session)
      // const alreadyPaidSession= session.payouts.map((pay=> pay.sessions.reduce((a,b)=> b.sessionId===session._id?a+b.paidAmount:0,0))).reduce((a,b)=>a+b,0)
      // console.log('alreadyPaidSession',alreadyPaidSession)
      const currency = session.sessionInfo.currency;
    // Find the matching session in `data`
    const matched = data.filter(
      (da) =>
        da.host.user === session.host.user &&
        da.sessionInfo.currency === session.sessionInfo.currency
    );

    if (matched.length === 0) return;
    console.log('matched',matched);
    
    const new2 = matched.map(sel=>{
       const alreadyPaidSession= sel.payouts.map((pay=> pay.sessions.filter(f=>f.sessionId===sel._id)?.reduce((a,b)=>a+b.paidAmount,0)))?.reduce((a,b)=>a+b,0)
      console.log('alreadyPaidSession',alreadyPaidSession)
      console.log('sel._id===session._id',sel._id===session._id,sel._id,session._id)

      const isSelected = String(sel._id) === String(session._id);
      const netAmount = sel.sessionInfo.duration * sel.sessionInfo.rate * 0.8
      const balance = netAmount - alreadyPaidSession
      return{
      sessionId: sel._id,
      start: sel.sessionInfo.start,
      amount: sel.sessionInfo.duration * sel.sessionInfo.rate,
      hostName: sel.host.name,
      hostImg: sel.host.img,
      hostId: sel.host.user,
      netAmount,
      alreadyPaidSession:alreadyPaidSession,      
      totalPaid:isSelected? balance:0,      
      paidAmount: isSelected? balance:0,
      paymentDate: Date.now(),
      paymentRef: '',
      attachments: [],
      comment:""
    }});

    // Overwrite state with only this session under its currency
    setSelectedSessions({
      [currency]:new2
    });
  
    }
    async function fetchPayoutDetail({id,payout, totalPaid,balance}){
    console.log("fetchPayoutDetail","totalPaid,balance",totalPaid,balance,payout)
      // return 
       setLoading(pre=>({...pre,spinner:true}))
    const response = await apiDemy.fetchPayoutDetail({
      token: user?.token,
      id    
    });
    setLoading(pre=>({...pre,spinner:false}))
    console.log("fetchPayoutDetail",response.data)
    if (response.error)
      return messageRef.current.showError({ message: response.error });
    const da = response.data;
    const currency = da.currency
    const new2 = da.sessions.map(res => {
      const se = res.sessionId
      return {
        sessionId: se._id,
        start: se.sessionInfo.start,
        amount: se.sessionInfo.duration * se.sessionInfo.rate,
        hostName: se.host.name,
        hostImg: se.host.img,
      hostId: se.host.user,
      netAmount: se.sessionInfo.duration * se.sessionInfo.rate * 0.8,
      totalPaid: da.totalPaid,
      alreadyPaidSession:0,
      paidAmount: res.paidAmount,
      paymentDate:da.paymentDate,
      paymentRef: da.paymentRef,
      attachments: da.attachments,
      comment: da.comment,
      paymentMethod: da.paymentMethod,
      action: "edit",
      payoutId: da._id
    }});

    // Overwrite state with only this session under its currency
    setSelectedSessions({
      [currency]:new2
    });

    }

    async function modifyHandle(){
      if(window.confirm("Are you sure to modify the payment details?")!==true)return
  setLoading(pre=>({...pre,spinner:true}))
  const da = {...selectedSessions}
      for (let currency in da) {
        da[currency]=da[currency].filter(f=>Number(f.paidAmount>0))
      }
    
  const response = await apiDemy.modifyPayoutDetail({
      token: user?.token,
      data:da    
    });
    setLoading(pre=>({...pre,spinner:false}))
    console.log("modifyPayoutDetail",response.data)
     if (response.error)return messageRef.current.showError({ message: response.message })
     messageRef.current.showSuccess({ message: response.message })
      // const updatedData = data?.map(se=>response.data.find(s=>s._id === se._id) || se)
      // setData(updatedData)
       fetchData()
    }
    async function deletePayoutHandle(payoutId){
if (!payoutId) {
    return messageRef.current.showError({ message: "Invalid payout ID" });
  }
      if(window.confirm("Are you sure to delete payment?")!==true)return
  setLoading(pre=>({...pre,spinner:true}))
    
  const response = await apiDemy.deletePayout({
      token: user?.token,
      payoutId    
    });
    setLoading(pre=>({...pre,spinner:false}))
    console.log("modifyPayoutDetail",response.data)
     if (response.error)return messageRef.current.showError({ message: response.message })
     messageRef.current.showSuccess({ message: response.message })
      // const updatedData = data?.map(se=>response.data.find(s=>s._id === se._id) || se)
      // setData(updatedData)
       fetchData()
    }
    async function payoutHandle(){
      if(totalPaid<=0)return messageRef.current.showError({ message: "Please enter a valid paid amount." });  
      if(Object.keys(selectedSessions)?.[0]?.length===0) return messageRef.current.showError({ message: "Please select at least one session." });
       if(selectedSessions[Object.keys(selectedSessions)[0]]?.[0]?.action==='edit')return modifyHandle()
       
      const da = {...selectedSessions}
      for (let currency in da) {
        da[currency]=da[currency].filter(f=>Number(f.totalPaid>0)).map(se=>({...se,totalPaid}))
      }
      console.log('da',da)    
      if(window.confirm("Are you sure to submit this payment?")!==true)return  
      setLoading(pre=>({...pre,spinner:true}))  
      const response = await apiDemy.payoutHandle({
        token: user.token,
        data:da,
      });
      setLoading(pre=>({...pre,spinner:false}))  
      if(response.error)return messageRef.current.showError({ message: response.error })
      messageRef.current.showSuccess({ message: response.message })
      const updatedData = data?.map(se=>response.data.find(s=>s._id === se._id) || se)
      setData(updatedData)
    }

  
    const selectedFiltersRender = (() => {
      let rows = [];
      for (let key in filters) {
        if (Array.isArray(filters[key]))
          filters[key].map((option, i) => {
            // console.log(key, renderData[key], option);
            if (
              key !== "states" &&
              key !== "cities" &&
              key !== "subCat" &&
              key !== "subCatId"
            ) {
              const translate = (renderData[key] || demyData[key]).find(
                (option1) => option1.name == option
              );
              rows.push(
                <div
                  key={[option, i]}
                  className=" btn-search shadow-none m-2 d-flex justify-content-between align-items-center"
                >
                  <span>{translate?.[window.lang]} </span>
                  <span
                    className="ms-3 me-2"
                    id={[key, i]}
                    onClick={deleteArrayFilter}
                  >
                    <i className="bi bi-x-lg"></i>
                  </span>
                </div>
              );
            }
  
            if (key === "states" || key === "cities" || key === "subCat") {
              rows.push(
                <div
                  key={[option, i]}
                  className=" btn-search shadow-none m-2 d-flex justify-content-between align-items-center"
                >
                  <span>{option} </span>
                  <span
                    className="ms-3 me-2"
                    id={[key, i]}
                    onClick={deleteArrayFilter}
                  >
                    <i className="bi bi-x-lg"></i>
                  </span>
                </div>
              );
            }
          });
  
        !Array.isArray(filters[key]) &&
          key !== "lang" &&
          key !== "countryShort" &&
          key !== "stateShort" &&
          key !== "state" &&
          key !== "section" &&
          key !== "sort" &&
          key !== "pageNumber:" &&
          key !== "itemsToShow" &&
          key !== "mainCatId" &&
          key !== "access" &&
          filters[key]?.length &&
          rows.push(
            <div className=" btn-search shadow-none m-2 d-flex justify-content-between align-items-center">
              <span>
                {key === "tag" && "# "}
                {filters[key]}
              </span>
              <span className="ms-3 me-2" id={key} onClick={deleteFilter}>
                <i className="bi bi-x-lg"></i>
              </span>
            </div>
          );
      }
      return rows;
    })();


   

  return (
    <div className="userList" style={{ height: "100vh", width: "100%" }}>
      <ToastNote messageRef={messageRef} />
      {loading.spinner && <ColoredSpinner />}
      <section className="mx-auto ads-all py-0">
<div className="row blog px-md-4 p-0 py-1">
          {/* <!-- **************Right side ************** --> */}
          <div className="col-lg-12 entries  ">
            {/* <!-- ************** MAP ************** --> */}
            <a id="top"> </a>

            {/* <!-- **************Filters  ************** --> */}
            <div className=" d-flex flex-wrap x-3 justify-content-between my-2 border-0 ">
              <div className="d-flex">
                {/* <span className="pt-2" title="Show saved items">
                  <i
                    className={`bi ${
                      filters.saved ? "bi-bookmark-fill" : "bi-bookmark"
                    } icon-stack-1x cursor`}
                    onClick={(e) => {
                      if (!window.logined(9999)) return;
                      if (user?.saved?.[section]?.length <= 0)
                        return alert("You have no saved items yet!");
                      setFilters((pre) => ({
                        ...initialFilters,
                        saved: !pre.saved,
                        section,
                      }));
                    }}
                  ></i>
                </span> */}
                {resultsTotal !== 0 && (
                  <span className="box4 py-1 px-2 mx-md-2 mx-0">
                    {resultsTotal} Result(s)
                  </span>
                )}
                <div className="blog-search ">
                  <BlogSearch searchHandle={searchHandle} />
                </div>
              </div>
              <div className="d-flex">
              
                <button
                  className="btn btn-primary button-filter me-md-3 me-0 ms-auto my-2"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarTogglerDemo02"
                  aria-controls="navbarTogglerDemo02"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <i className="bi bi-filter me-1"> Filters</i>
                </button>
              </div>
              <div
                className="collapse navbar-collapse "
                id="navbarTogglerDemo02"
              >
                <div className="d-flex flex-wrap mt-3">
                  {/* <!-- Button filter 1 *******************************--> */}
                  <div className="dropdown">
                    <button
                      type="button"
                      className="btn  button-filter dropdown-toggle"
                      data-bs-toggle="dropdown"
                      // id="#filter5"
                      aria-expanded="false"
                      // aria-controls="filter5"
                    >
                      <span>
                        <i className="bi bi-arrow-down-up me-1"></i>
                      </span>
                      Sort
                      {/* {filters.sort !== "default" && <CheckBox />} */}
                      <span className="ps-3">
                        <i className="bi bi-chevron-down"></i>
                      </span>
                    </button>

                    {/* <!-- Modal --> */}

                    <div className="dropdown-menu checkbox-form px-0 ">
                      <div className=" ">
                        <div className="form-check px-3 d-flex justify-content-between flex-row-reverse">
                          <input
                            className="form-check-input "
                            type="radio"
                            name="flexRadioDefault"
                            id="flexRadioDefault1"
                            checked={filters.sort === "default"}
                            onChange={(e) => {
                              setFilters((prev) => ({
                                ...prev,
                                sort: "default",
                                pageNumber: 1,
                              }));
                              // effectRan.current = false;
                            }}
                          />
                          <label
                            className="form-check-label "
                            htmlFor="flexRadioDefault1"
                          >
                            Default
                          </label>
                        </div>

                        <div className="form-check px-3 d-flex justify-content-between flex-row-reverse">
                          <input
                            className="form-check-input "
                            type="radio"
                            name="flexRadioDefault"
                            id="flexRadioDefault2"
                            checked={filters.sort === "dateB"}
                            onChange={(e) => {
                              // effectRan.current = false;
                              setFilters((prev) => ({
                                ...prev,
                                sort: "dateB",
                                pageNumber: 1,
                              }));
                            }}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="flexRadioDefault2"
                          >
                            Newest First
                          </label>
                        </div>
                        <div className="form-check px-3 d-flex justify-content-between  flex-row-reverse">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="flexRadioDefault"
                            id="flexRadioDefault3"
                            // value={flexRadioDefault3}
                            checked={filters.sort === "priceB"}
                            onChange={(e) => {
                              // effectRan.current = false;
                              setFilters((prev) => ({
                                ...prev,
                                sort: "priceB",
                                pageNumber: 1,
                              }));
                            }}
                          />
                          <span className="checkmark-radio-btn "></span>
                          <label
                            className="form-check-label "
                            htmlFor="flexRadioDefault3"
                          >
                            Fees (Low to High)
                          </label>
                        </div>
                        <div className="form-check px-3 d-flex justify-content-between  flex-row-reverse">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="flexRadioDefault"
                            id="flexRadioDefault334"
                            // value={flexRadioDefault334}
                            checked={filters.sort === "priceA"}
                            onChange={(e) => {
                              // effectRan.current = false;
                              setFilters((prev) => ({
                                ...prev,
                                sort: "priceA",
                                pageNumber: 1,
                              }));
                            }}
                          />
                          <span className="checkmark-radio-btn "></span>
                          <label
                            className="form-check-label "
                            htmlFor="flexRadioDefault334"
                          >
                             Fees (High to Low)
                          </label>
                        </div>
                      
                      </div>
                    </div>
                  </div>
                  {/* <!-- Button country 2 *******************************--> */}
                  <div className="dropdown">
                    <button
                      type="button"
                      className="btn button-filter dropdown-toggle"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <span>
                        <i className="bi bi-geo-alt me-1"></i>
                      </span>
                      Status
                      <span className="ps-3">
                        <i className="bi bi-chevron-down"></i>
                      </span>
                    </button>

                    {/* <!-- Modal --> */}

                    <div className="dropdown-menu checkbox-form">
                      {/* <DropdownSearch updateParent={countrySet} /> */}
                      
                    </div>
                  </div>
                  {loading.currencies ? (
                    <CircularProgress color="inherit" size="20px" />
                  ) : (
                    <select
                      className={`login-btn my-0`}
                      name="salaryCurrency"
                      value={filters.currency}
                      onChange={handleChange}
                    >
                      <option value=""> Currency</option>
                      {currencies.map((curr) => (
                        <option
                          key={curr.currency} // Add a unique key
                          value={curr.currency} // Set the currency value
                          data-exRate={curr.exRate} // Set the exchange rate in dataset
                        >
                          {curr.currency_name}
                        </option>
                      ))}
                      {currencies.length < 10 && (
                        <option value="more">
                          {" "}
                          <div className="bg-redDark font-20">More... </div>
                        </option>
                      )}
                    </select>
                  )}
                  <div>

                  </div>

                11111

                  {/* <!-- Button filter 5 *******************************--> */}
                  <div className="dropdown">
                    <button
                      className="btn button-filter"
                      type="button"
                      data-bs-toggle="offcanvas"
                      data-bs-target="#offcanvasWithBothOptionsFilters"
                      aria-controls="offcanvasWithBothOptionsFilters"
                    >
                      <span>
                        <i className="bi bi-filter me-1"></i>
                      </span>
                      More Filters
                      <span className="ps-3">
                        <i className="bi bi-chevron-down"></i>
                      </span>
                    </button>

                    <div
                      className="offcanvas offcanvas-end offcanvas-countryLanguage "
                      data-bs-scroll="true"
                      tabIndex="-1"
                      id="offcanvasWithBothOptionsFilters"
                      aria-labelledby="offcanvasWithBothOptionsLabelFilters"
                    >
                      <div className="offcanvas-header offcanvas-countryLanguageTitle ">
                        <h5
                          className="offcanvas-title "
                          id="offcanvasWithBothOptionsLabelFilters"
                        >
                          More Filters
                        </h5>
                        <button
                          type="button"
                          className="btn-close"
                          data-bs-dismiss="offcanvas"
                          aria-label="Close"
                        ></button>
                      </div>

                      <div className="offcanvas-footer  text-center px-5 py-4">
                        <button
                          className="btn  checkout-btn  text-center w-100 mb-2 py-2"
                          type="button"
                          data-bs-dismiss="offcanvas"
                          aria-label="Close"
                         onClick={(e) => {
                    // removing all url queries
                    navigate('')
                    setFilters(initialFilters)
                  }}
                        >
                        Clear All Filters
                        </button>
                        <button
                          className="btn  view-cart text-center w-100 py-2"
                          type="button"
                          data-bs-dismiss="offcanvas"
                          aria-label="Close"
                          onClick={(e) => {
                            // effectRan.current = false;
                            backFilters.pageNumber = 1;
                            setFilters(backFilters);
                          }}
                        >
                          View Results
                        </button>
                      </div>

                      <div className="offcanvas-body px-0 pb-3 pt-0">
                        <div
                          className="accordion w-100 p-0 m-0"
                          id="accordionPanelsStayOpenBusinessFilters"
                        >
                          <div className="accordion-item">
                            <h2
                              className="accordion-header"
                              id="panelsStayOpenBusinessFilters-headingZero"
                            >
                              <button
                                className="accordion-button collapsed accordion-button-business-filter"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#panelsStayOpenBusinessFilters-collapseZero"
                                aria-expanded="false"
                                aria-controls="panelsStayOpenBusinessFilters-collapseZero"
                              >
                                <p className="form-titr2">Rating </p>
                              </button>
                            </h2>
                            <div
                              id="panelsStayOpenBusinessFilters-collapseZero"
                              className="accordion-collapse collapse"
                              aria-labelledby="panelsStayOpenBusinessFilters-headingZero"
                            >
                              <div className="accordion-body form-font px-5">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    value="4"
                                    checked={
                                      backFilters?.rate?.slice(0, 1) == 4
                                    }
                                    id={`flexCheckRates4`}
                                    name="rateFilter"
                                    onChange={(e) => {
                                      setBackFilters((prev) => ({
                                        ...prev,
                                        rate: "4 Stars & up",
                                        pageNumber: 1,
                                      }));
                                    }}
                                  />

                                  <label
                                    className="form-check-label d-flex"
                                    htmlFor={`flexCheckRates4`}
                                  >
                                    <div className="star-filter me-1">
                                      <i className="bi bi-star-fill ps-1"></i>
                                      <i className="bi bi-star-fill ps-1"></i>
                                      <i className="bi bi-star-fill ps-1"></i>
                                      <i className="bi bi-star-fill ps-1"></i>
                                      <i className="bi bi-star ps-1"></i>
                                    </div>
                                    <span className="small-gray-font pt-1"> & up</span>
                                  </label>
                                </div>
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    value="3"
                                    checked={
                                      backFilters?.rate?.slice(0, 1) == 3
                                    }
                                    id={`flexCheckRates3`}
                                    name="rateFilter"
                                    onChange={(e) => {
                                      setBackFilters((prev) => ({
                                        ...prev,
                                        rate: "3 Stars & up",
                                        pageNumber: 1,
                                      }));
                                      // effectRan.current = false;
                                    }}
                                  />
                                  <label
                                    className="form-check-label d-flex"
                                    htmlFor={`flexCheckRates3`}
                                  >
                                    <div className="star-filter me-1">
                                      <i className="bi bi-star-fill ps-1"></i>
                                      <i className="bi bi-star-fill ps-1"></i>
                                      <i className="bi bi-star-fill ps-1"></i>
                                      <i className="bi bi-star ps-1"></i>
                                      <i className="bi bi-star ps-1"></i>
                                    </div>
                                    <span className="small-gray-font pt-1"> & up</span>
                                  </label>
                                </div>
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    value="2"
                                    checked={
                                      backFilters?.rate?.slice(0, 1) == 2
                                    }
                                    onChange={(e) => {
                                      setBackFilters((prev) => ({
                                        ...prev,
                                        rate: "2 stars & up",
                                        pageNumber: 1,
                                      }));
                                      // effectRan.current = false;
                                    }}
                                    id={`flexCheckRates2`}
                                    name="rateFilter"
                                  />
                                  <label
                                    className="form-check-label d-flex"
                                    htmlFor={`flexCheckRates2`}
                                  >
                                    <div className="star-filter me-1">
                                      <i className="bi bi-star-fill ps-1"></i>
                                      <i className="bi bi-star-fill ps-1"></i>
                                      <i className="bi bi-star ps-1"></i>
                                      <i className="bi bi-star ps-1"></i>
                                      <i className="bi bi-star ps-1"></i>
                                    </div>
                                    <span className="small-gray-font pt-1"> & up</span>
                                  </label>
                                </div>

                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    value="1"
                                    checked={
                                      backFilters?.rate?.slice(0, 1) == 1 &&
                                      true
                                    }
                                    onChange={(e) => {
                                      setBackFilters((prev) => ({
                                        ...prev,
                                        rate: "1 star & up",
                                        pageNumber: 1,
                                      }));
                                      // effectRan.current = false;
                                    }}
                                    id={`flexCheckRates1`}
                                    name="rateFilter"
                                  />
                                  <label
                                    className="form-check-label d-flex"
                                    htmlFor={`flexCheckRates1`}
                                  >
                                    <div className="star-filter me-1">
                                      <i className="bi bi-star-fill ps-1"></i>
                                      <i className="bi bi-star ps-1"></i>
                                      <i className="bi bi-star ps-1"></i>
                                      <i className="bi bi-star ps-1"></i>
                                      <i className="bi bi-star ps-1"></i>
                                    </div>
                                    <span className="small-gray-font pt-1"> & up</span>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="accordion-item">
                            <h2
                              className="accordion-header"
                              id="panelsStayOpenBusinessFilters-headingZero"
                            >
                              <button
                                className="accordion-button collapsed accordion-button-business-filter"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#stayOpenWeedkDays"
                                aria-expanded="false"
                                aria-controls="stayOpenWeedkDays"
                              >
                                <p className="form-titr2">Availability (Weekdays)</p>
                              </button>
                            </h2>
                            <div
                              id="stayOpenWeedkDays"
                              className="accordion-collapse collapse"
                              aria-labelledby="panelsStayOpenBusinessFilters-headingZero"
                            >
                              <div className="accordion-body form-font px-5  row row-cols-2">
                                {renderData.weekDays.map((ad, i) => (
                                  <div
                                    key={i}
                                    className="form-check m-0 py-0 px-1"
                                  >
                                    <input
                                      className="form-check-input form-check-input-filter1 m-0 p-0"
                                      type="checkbox"
                                      name="weekDay"
                                      value={ad.name}
                                      id={`weekDay,${i}`}
                                      checked={backFilters?.weekDays?.includes(
                                        ad.name
                                      )}
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        const weekDays = backFilters?.weekDays
                                          ? [...backFilters.weekDays]
                                          : [];
                                        const index = weekDays.indexOf(value);
                                        if (index !== -1) {
                                          weekDays.splice(index, 1);
                                        } else {
                                          weekDays.push(ad.name);
                                        }
                                        setBackFilters((prev) => ({
                                          ...prev,
                                          weekDays,
                                        }));
                                      }}
                                    />
                                    <label
                                      className="form-check-label px-2"
                                      htmlFor={`weekDay,${i}`}
                                    >
                                      {ad?.[window.lang]}
                                    </label>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                          <div className="accordion-item">
                            <h2
                              className="accordion-header"
                              id="panelsStayOpenBusinessFilters-headingTwo"
                            >
                              <button
                                className="accordion-button collapsed accordion-button-business-filter"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#panelsStayOpenBusinessFilters-collapseTwo"
                                aria-expanded="false"
                                aria-controls="panelsStayOpenBusinessFilters-collapseTwo"
                              >
                                <p className="form-titr2">Age Group</p>
                              </button>
                            </h2>
                            <div
                              id="panelsStayOpenBusinessFilters-collapseTwo"
                              className="accordion-collapse collapse"
                              aria-labelledby="panelsStayOpenBusinessFilters-headingTwo"
                            >
                              <div className="accordion-body form-font px-5">
                                {renderData.ageGroups.map((at, i) => (
                                  <div key={i} className="form-check">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      value={at.name}
                                      checked={backFilters?.ageGroups?.includes(
                                        at.name
                                      )}
                                      id={`checkBoxavailableTime${i}`}
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        const ageGroups = backFilters.ageGroups
                                          ? [...backFilters.ageGroups]
                                          : []; // Create a shallow copy of the array
                                        console.log("ageGroups", ageGroups);
                                        const index =
                                          backFilters.ageGroups.indexOf(value);
                                        if (index !== -1) {
                                          ageGroups.splice(index, 1);
                                        } else {
                                          // Add the value if it's not selectedSessions
                                          ageGroups.push(value);
                                        }
                                        // backFilters.ageGroups=ageGroups
                                        setBackFilters((pre) => ({
                                          ...pre,
                                          ageGroups,
                                        }));
                                      }}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor={`checkBoxavailableTime${i}`}
                                    >
                                      {at[lang]}
                                    </label>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>

                          <div className="accordion-item">
                            <h2
                              className="accordion-header"
                              id="panelsStayOpenBusinessFilters-headingOne"
                            >
                              <button
                                className="accordion-button collapsed accordion-button-business-filter "
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#panelsStayOpenBusinessFilters-collapseOne"
                                aria-expanded="false"
                                aria-controls="panelsStayOpenBusinessFilters-collapseOne"
                              >
                                <p className="form-titr2">Language</p>
                              </button>
                            </h2>
                            <div
                              id="panelsStayOpenBusinessFilters-collapseOne"
                              className="accordion-collapse collapse"
                              aria-labelledby="panelsStayOpenBusinessFilters-headingOne"
                            >
                              <div className="accordion-body form-font px-5  row row-cols-3 ">
                                {renderData.languages.map((lang, i) =>
                                  !lang.fa.length ? (
                                    ""
                                  ) : (
                                    <div key={i} className="morelang-line">
                                      <input
                                        className="form-check-input  red moreLang"
                                        type="checkbox"
                                        value={lang.name}
                                        checked={backFilters.languages?.includes(
                                          lang.name
                                        )}
                                        id={`flexLanguages${i}`}
                                        onChange={(e) => {
                                          const languages =
                                            backFilters?.languages
                                              ? [...backFilters.languages]
                                              : [];
                                          const value = e.target.value;
                                          const index =
                                            languages.indexOf(value);
                                          if (index !== -1) {
                                            languages.splice(index, 1);
                                          } else {
                                            languages.push(value);
                                          }
                                          setBackFilters((pre) => ({
                                            ...pre,
                                            languages,
                                          }));
                                        }}
                                      />
                                      <label
                                        className="form-check-label ps-2 red moreLang"
                                        htmlFor={`flexLanguages${i}`}
                                      >
                                        {lang[window.lang]}
                                      </label>
                                    </div>
                                  )
                                )}

                                <button
                                  className="btn button-filter py-0 mt-3"
                                  type="button"
                                >
                                  <label htmlFor="moreLangCheckbox">
                                    {" "}
                                    more...{" "}
                                  </label>
                                  {/* <span>
                              <i className="bi bi-three-dots ps-2 py-0 my-0"></i>
                            </span> */}
                                  <input
                                    id="moreLangCheckbox"
                                    type="checkbox"
                                    onClick={(e) => {
                                      const elemet =
                                        document.querySelectorAll(".moreLang");
                                      if (e.target.checked) {
                                        document.querySelector(
                                          "label[for=moreLangCheckbox]"
                                        ).innerHTML = "less...";
                                        Array.from(elemet).map(
                                          (el) =>
                                            (el.style.display = "inline-block")
                                        );
                                      } else {
                                        document.querySelector(
                                          "label[for=moreLangCheckbox]"
                                        ).innerHTML = " more...";
                                        Array.from(elemet).map(
                                          (el) => (el.style.display = "none")
                                        );
                                      }
                                    }}
                                  />
                                </button>
                              </div>
                            </div>
                          </div>

                          <div className="accordion-item">
                            <h2
                              className="accordion-header"
                              id="panelsStayOpenBusinessFilters-headingThree"
                            >
                              <button
                                className="accordion-button collapsed accordion-button-business-filter"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#panelsStayOpenBusinessFilters-collapseThree"
                                aria-expanded="false"
                                aria-controls="panelsStayOpenBusinessFilters-collapseThree"
                              >
                                <p className="form-titr2">Course Level </p>
                              </button>
                            </h2>
                            <div
                              id="panelsStayOpenBusinessFilters-collapseThree"
                              className="accordion-collapse collapse"
                              aria-labelledby="panelsStayOpenBusinessFilters-headingThree"
                            >
                              <div className="accordion-body form-font px-5">
                                {demyData.tutorLevel
                                  .slice(0, 2)
                                  .map((tr, i) => (
                                    <div
                                      key={i}
                                      className="form-check form-switch m-0 py-0 px-1"
                                    >
                                      <input
                                        className="form-check-input form-check-input-filter1 m-0 p-0"
                                        type="checkbox"
                                        role="switch"
                                        name="tutorLevel"
                                        value={tr.name}
                                        id={`tutorLevel,${i}`}
                                        checked={backFilters?.tutorLevel?.includes(
                                          tr.name
                                        )}
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          const tutorLevel =
                                            backFilters.tutorLevel
                                              ? [...backFilters.tutorLevel]
                                              : [];
                                          const index =
                                            tutorLevel.indexOf(value);
                                          if (index !== -1) {
                                            tutorLevel.splice(index, 1);
                                          } else {
                                            tutorLevel.push(tr.name);
                                          }
                                          setBackFilters((prev) => ({
                                            ...prev,
                                            tutorLevel,
                                          }));
                                        }}
                                      />
                                      <label
                                        className="form-check-label px-2"
                                        htmlFor={`tutorLevel,${i}`}
                                      >
                                        {tr?.[window.lang]}
                                      </label>
                                    </div>
                                  ))}
                              </div>
                            </div>
                          </div>

                          <div className="accordion-item">
                            <h2
                              className="accordion-header"
                              id="panelsStayOpenBusinessFilters-heading-Five"
                            >
                              <button
                                className="accordion-button collapsed accordion-button-business-filter"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#panelsStayOpenBusinessFilters-collapse-Five"
                                aria-expanded="false"
                                aria-controls="panelsStayOpenBusinessFilters-collapse-Five"
                              >
                                <p className="form-titr2">
                                  {" "}
                                  Class Format
                                </p>
                              </button>
                            </h2>
                            <div
                              id="panelsStayOpenBusinessFilters-collapse-Five"
                              className="accordion-collapse collapse"
                              aria-labelledby="panelsStayOpenBusinessFilters-heading-Five"
                            >
                              <div className="accordion-body form-font px-5">
                                {renderData.serviceTypes
                                  .slice(0, 2)
                                  .map((tr, i) => (
                                    <div
                                      key={i}
                                      className="form-check form-switch m-0 py-0 px-1"
                                    >
                                      <input
                                        className="form-check-input form-check-input-filter1 m-0 p-0"
                                        type="checkbox"
                                        role="switch"
                                        name="serviceTypes"
                                        value={tr.name}
                                        id={`serviceTypes,${i}`}
                                        checked={backFilters?.serviceTypes?.includes(
                                          tr.name
                                        )}
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          const serviceTypes =
                                            backFilters.serviceTypes
                                              ? [...backFilters.serviceTypes]
                                              : [];
                                          const index =
                                            serviceTypes.indexOf(value);
                                          if (index !== -1) {
                                            serviceTypes.splice(index, 1);
                                          } else {
                                            serviceTypes.push(tr.name);
                                          }
                                          setBackFilters((prev) => ({
                                            ...prev,
                                            serviceTypes,
                                          }));
                                        }}
                                      />
                                      <label
                                        className="form-check-label px-2"
                                        htmlFor={`serviceTypes,${i}`}
                                      >
                                        {tr?.[window.lang]}
                                      </label>
                                    </div>
                                  ))}
                              </div>
                            </div>
                          </div>
                          <div className="accordion-item">
                            <h2
                              className="accordion-header"
                              id="panelsStayOpenBusinessFilters-heading-six"
                            >
                              <button
                                className="accordion-button collapsed accordion-button-business-filter"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#panelsStayOpenBusinessFilters-collapse-six"
                                aria-expanded="false"
                                aria-controls="panelsStayOpenBusinessFilters-collapse-six"
                              >
                                <p className="form-titr2"> Others</p>
                              </button>
                            </h2>
                            <div
                              id="panelsStayOpenBusinessFilters-collapse-six"
                              className="accordion-collapse collapse"
                              aria-labelledby="panelsStayOpenBusinessFilters-heading-six"
                            >
                              <div className="accordion-body form-font px-5">
                                <div className="form-check form-switch m-0 py-0 px-1">
                                  <input
                                    className="form-check-input form-check-input-filter1 m-0 p-0"
                                    type="checkbox"
                                    role="switch"
                                    name="img"
                                    // value={'tr.name'}
                                    id={`imgBackF`}
                                    checked={backFilters?.img}
                                    onChange={(e) => {
                                      setBackFilters((prev) => ({
                                        ...prev,
                                        img: prev?.img?.length
                                          ? ""
                                          : "With photo",
                                      }));
                                    }}
                                  />
                                  <label
                                    className="form-check-label px-2"
                                    htmlFor={`imgBackF`}
                                  >
                                    With photo
                                  </label>
                                </div>
                                <div className="form-check form-switch m-0 py-2 px-1">
                                  <input
                                    className="form-check-input form-check-input-filter1 m-0 p-0"
                                    type="checkbox"
                                    role="switch"
                                    name="video"
                                    // value={'tr.name'}
                                    id={`videoBackF`}
                                    checked={backFilters?.video}
                                    onChange={(e) => {
                                      setBackFilters((prev) => ({
                                        ...prev,
                                        video: prev?.video?.length
                                          ? ""
                                          : "With Video",
                                      }));
                                    }}
                                  />
                                  <label
                                    className="form-check-label px-2"
                                    htmlFor={`videoBackF`}
                                  >
                                    With Video
                                  </label>
                                </div>
                                <div className="form-check form-switch m-0 py-2 px-1">
                                  <input
                                    className="form-check-input form-check-input-filter1 m-0 p-0"
                                    type="checkbox"
                                    role="switch"
                                    name="freeSession"
                                    // value={'tr.name'}
                                    id={`freeSessionBackF`}
                                    checked={backFilters?.freeSession}
                                    onChange={(e) => {
                                      setBackFilters((prev) => ({
                                        ...prev,
                                        freeSession: prev.freeSession?.length
                                          ? ""
                                          : "Trial session",
                                      }));
                                    }}
                                  />
                                  <label
                                    className="form-check-label px-2"
                                    htmlFor={`freeSessionBackF`}
                                  >
                                  Offers Trial Session
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* ***************** */}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className=" d-flex flex-wrap my-2 show-filters ">
              {selectedFiltersRender}
              {selectedFiltersRender.length > 0 && (
                <div
                  className=" btn-search shadow-none m-2 d-flex justify-content-between align-items-center img-banner-text-7 px-3 filter-del-btn"
                 onClick={(e) => {
                    // removing all url queries
                    navigate('')
                    setFilters(initialFilters)
                  }}
                >
                  <span>Remove Filters</span>
                </div>
              )}
            </div>

            {/* <!-- Pagination *******************************--> */}
            <div className="mx-1 p-0 ">
              <div className="g-2 mb-3">
                <Pagination
                  data={{ resultsTotal, itemsToShow: filters.itemsToShow }}
                  setPageNumber={pageNumberHandle}
                  pageNumber={filters.pageNumber}
                  setItemsToShow={itemsToShowHandle}
                  position="top"
                />
              </div>

              <div>
                {loading.fetchBus ? (
                  <img src="/img/searching-error.svg" alt="Searching..." />
                ) : (
                  data?.length &&
                  !loading.fetchBus <= 0 && (
                    <div className="row m-5 px-md-5 px-0">
                      <div className="col-md-6 d-flex align-items-center justify-content-center px-0">
                        No Data where found
                        <div
                          className="btn-search shadow-none m-2 d-flex  align-items-center filter-del-btn img-banner-text-7"
                          onClick={(e) =>
                            document.querySelector("#lcsChangeBtn").click()
                          }
                        >
                          Other countries
                        </div>
                      </div>
                      <div className="col-md-6 d-flex align-items-center justify-content-center">
                        <img
                          src="/img/cart-is-empty.svg"
                          alt="cart-is-empty"
                          loading="lazy"
                        />
                      </div>
                    </div>
                  )
                )}
                {/* <!-- ************** Cards************** --> */}

                <div
                  className="row row-cols-1 
              g-4"
                > render rows
                  {/* {data?.map((da, i) => (
                    <div className="metademy-en" key={i}>
                      <TutorCard
                        data={da}
                        currencies={currencies}
                        setVideo={setVideo}
                        setActiveTutor={setActiveTutor}
                      />
                    </div>
                  ))} */}
   <table className="table">
        <thead>
          <tr>
            <th>Host</th>
            <th>Guest</th>
            <th>Date</th>
            <th>Status</th>
            <th>Net Amount</th>
            <th>Payments</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {data?.map((session) => {
            const currentStatus = session.history?.[0]?.status;
            const { netAmount, balance } = calculatePaymentInfo(session);

            return (
              <tr key={session._id}>
                {/* Host */}
                <td>
                  <img
                    className="img-fluid jobCrad-img2"
                    src={session?.host?.img}
                    alt={session?.host?.userName}
                  />
                  <div className="small-gray-font">{session.host.name}</div>
                </td>

                {/* Guest */}
                <td>{session?.guest?.userName}</td>

                {/* Date */}
                <td>
                  {tools.dynamicDate({
                    date: session.sessionInfo?.start,
                    countryShort: "CA",
                    lang: window.lang,
                  })}
                </td>

                {/* Status */}
                <td>
                  {tools.renderTrans({ section: "status", key: currentStatus })}
                </td>

                {/* Net amount */}
                <td>
                  {tools.showPrice(
                    netAmount,
                    session?.sessionInfo?.currency
                  )}
                </td>

                {/* Payment history */}
                <td>
                  <PaymentHistory
                    session={session}
                    fetchPayoutDetail={fetchPayoutDetail}
                    balance={balance}
                  />
                 
                </td>

                {/* Action */}
                <td
                  className="small-gray-font link"
                  data-bs-toggle="modal"
                  data-bs-target="#bookingModal"
                  onClick={() => setSelectionsHandle(session)}
                >
                  {getSessionPaymentStatus(session) !== "paid"? <div>Make Payment</div>:<div></div>}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

                </div>
              </div>

              <div className="mt-5 ">
                <Pagination
                  data={{ resultsTotal, itemsToShow: filters.itemsToShow }}
                  setPageNumber={pageNumberHandle}
                  pageNumber={filters.pageNumber}
                  position="down"
                />
              </div>
            </div>
          </div>
          <div className="col-lg-1  sidebar-all align-items-center text-center  p-md-4 p-1">
            {/* <!-- ********left side *************************************************************** --> */}

            {/* <MainSidebar section={section} /> */}
          </div>
        </div>
      </section>   
      <div>     
 
    
      </div>  
       {/* Payment Modal */}
        <div
      className="modal fade"
      id="bookingModal"
      tabIndex="-1"
      aria-labelledby="claimModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title titr5" id="claimModalLabel">
             {selectedSessions[Object.keys(selectedSessions)[0]]?.[0]?.action==='edit'?"Modify Payment":"Make Payment"} 

            </h1>
            <button
              type="button"
              id="modal-colse-btn"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => setSelectedSessions({})}
            ></button>
          </div>

          <div className="modal-body">
            {/* Header inputs */}
            <div className="d-flex f-row justify-content-between">
              <div>
                Date :{" "}
                <input type="date" value={selectedSessions[Object.keys(selectedSessions)[0]]?.[0]?.paymentDate
                          ? new Date(
                              selectedSessions[Object.keys(selectedSessions)?.[0]]?.[0]?.paymentDate
                            )
                              ?.toISOString()
                              ?.split("T")[0] // "YYYY-MM-DD"
                          : ""}
                  onChange={(e) => {
                    const date = e.target.value;
                    const updated = {};
                    for (const cur of Object.keys(selectedSessions)) {
                      updated[cur] = selectedSessions[cur].map((s) => ({
                        ...s,
                        paymentDate: new Date(date),
                      }));
                    }
                    setSelectedSessions(updated);
                  }}
                />
              </div>

              <div>
                Payment Method :
                <select
                  className="login-btn selectpicker shadow-none w-30"
                 value={selectedSessions[Object.keys(selectedSessions)?.[0]]?.[0]?.paymentMethod}

                  onChange={(e) => {
                    const updated = {};
                    for (const cur of Object.keys(selectedSessions)) {
                      updated[cur] = selectedSessions[cur].map((s) => ({
                        ...s,
                        paymentMethod: e.target.value,
                      }));
                    }
                    setSelectedSessions(updated);
                  }}
                >
                  <option> Select:</option>
                  {renderData.payoutMethods?.map((pm, i) => (
                    <option key={i} value={pm.name}>
                      {pm[window.lang]}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                Reference :
                <input
                  type="text"
                  value={selectedSessions[Object.keys(selectedSessions)?.[0]]?.[0]?.paymentRef}
                  onChange={(e) => {
                    const updated = {};
                    for (const cur of Object.keys(selectedSessions)) {
                      updated[cur] = selectedSessions[cur].map((s) => ({
                        ...s,
                        paymentRef: e.target.value,
                      }));
                    }
                    setSelectedSessions(updated);
                  }}
                />
              </div>

              <div>Total Amount: {totalPaid.toLocaleString()}</div>
            </div>

            {/* Sessions table */}
            <table className="w-100 text-center mb-3">
              <thead className="font-14">
                <tr>
                  <th>✔</th>
                  <th>Date</th>
                  <th>Start</th>
                  <th>Host</th>
                  <th>Net Amount modal</th>
                  <th>Already Paid</th>
                  <th>Payment</th>
                </tr>
              </thead>
              <tbody className="font-12">
                {Object.keys(selectedSessions).map((cur) =>
                  selectedSessions[cur].map((sel, j) => (
                    <tr key={j}>
                      <td>
                        <input
                          type="checkbox"
                          className="form-check-input"
                          checked={sel.paidAmount > 0}
                          onChange={(e) => {
                            setSelectedSessions((prev) => {
                              const copy = { ...prev };
                              copy[cur] = copy[cur].map((s) =>
                                s.sessionId === sel.sessionId
                                  ? {
                                      ...s,
                                      paidAmount: e.target.checked
                                        ? sel.netAmount-sel.alreadyPaidSession
                                        : 0,
                                    }
                                  : s
                              );
                              return copy;
                            });
                          }}
                        />
                      </td>
                      <td>
                        {tools.dynamicDate({
                          date: sel.start,
                          countryShort: "CA",
                          lang: window.lang,
                        })}
                      </td>
                      <td dir="ltr">
                        {tools.dynamicTime({
                          date: sel.start,
                          countryShort: "CA",
                          lang: window.lang,
                          hour12: true,
                        })}
                      </td>
                      <td>{sel.hostName}</td>
                      <td>{`${cur} - ${sel.netAmount?.toLocaleString()}`}</td>
                      <td>
                        {`${cur} - ${sel.alreadyPaidSession?.toLocaleString()}`}
                      </td>
                      <td>
                        <input
                          type="text"
                          value={sel?.paidAmount?.toLocaleString() || ""}
                          onChange={(e) => {
                            const raw = e.target.value.replace(/,/g, "");
                            if (!/^\d*\.?\d*$/.test(raw)) return;
                            setSelectedSessions((prev) => {
                              const copy = { ...prev };
                              copy[cur] = copy[cur].map((s) =>
                                s.sessionId === sel.sessionId
                                  ? { ...s, paidAmount: raw }
                                  : s
                              );
                              return copy;
                            });
                          }}
                        />
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>

            {/* Comment + Save */}
            <div className="row">
              <div className="col-md-6 px-4">
                <textarea
                  className="claim-box mx-auto w-100"
                  rows={3}
                  placeholder="You can comment here if you wish..."
                  value={selectedSessions[Object.keys(selectedSessions)?.[0]]?.[0]?.comment || ""}
                  onChange={(e) => {
                    const updated = {};
                    for (const cur of Object.keys(selectedSessions)) {
                      updated[cur] = selectedSessions[cur].map((s) => ({
                        ...s,
                        comment: e.target.value,
                      }));
                    }
                    setSelectedSessions(updated);
                  }}
                />
              <div className="d-flex">
                <div
                  type="button"
                  className="btn btn-primary save-cover-btn bg-pinkOrange border-0 w-100 mx-1"
                  data-bs-dismiss="modal"
                  onClick={payoutHandle}
                >
                  {selectedSessions[Object.keys(selectedSessions)?.[0]]?.[0]?.action === "edit"
                    ? "Modify and Close"
                    : "Make a Payment"}
                </div>
                <div
                  type="button"
                  className="btn btn-primary save-cover-btn bg-pinkOrangeDark border-0 w-100 mx-1"
                  data-bs-dismiss="modal"
                  onClick={e=>deletePayoutHandle(selectedSessions[Object.keys(selectedSessions)?.[0]]?.[0]?.payoutId)}
                >
                  {selectedSessions[Object.keys(selectedSessions)?.[0]]?.[0]?.action === "edit"? "Delete Payment":""}
                </div>
                </div>
              </div>

              {/* Attachments */}
              <div className="col-md-6 align-items-center px-5 py-0 display-none-md">
                <div className="form-group d-flex files flex-column gap-2">
                  <input
                    className="form-control p-3"
                    type="file"
                    id="formFile2"
                    dir="ltr"
                    multiple
                    onChange={handleFileChange}
                  />

                  {selectedSessions[Object.keys(selectedSessions)?.[0]]?.[0]?.attachments?.length > 0 && (
                    <ul className="list-group mt-2">
                      {selectedSessions[Object.keys(selectedSessions)?.[0]]?.[0]?.attachments.map(
                        (file, index) => (
                          <li
                            key={index}
                            className="list-group-item d-flex justify-content-between align-items-center"
                          >
                            <span
                              style={{ cursor: "pointer", color: "#007bff" }}
                              onClick={() => openFileInNewTab(file)}
                              title="Click to open"
                            >
                              {file?.split("/")?.at(-1)}
                            </span>

                            <div className="btn-group">
                              <input
                                type="file"
                                title="Replace"
                                style={{ maxWidth: 120 }}
                                onChange={(e) =>
                                  handleReplaceFile(index, e.target.files[0])
                                }
                              />
                              <button
                                className="btn btn-sm btn-outline-danger"
                                onClick={() => handleRemoveFile(index)}
                              >
                                ✕
                              </button>
                            </div>
                          </li>
                        )
                      )}
                    </ul>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> 
    </div>      
    </div>
  );

function countrySet(countryShort) {
    const coun = countryStates.find(
      (count) => count.countryShort.toLowerCase() === countryShort.toLowerCase()
    );
    setStates(coun.states);
    setFilters((prev) => ({
      ...prev,
      country: coun.country,
      countryShort: countryShort.toLowerCase(),
      state: "",
      stateShort: "",
      states: [],
      cities: [],
    }));
  }
}




